import { array, boolean, mixed, number, object } from 'yup';

import { TSelectOption } from '@interfaces/components/componentTypes';

import {
	EFrequency,
	ERenotify,
	FrequencyValuesType,
	RenotifyValuesType,
	TFrequency,
	TRenotify,
} from '@enums/alarms';

import { getMaxLengthErrMsg, mandatoryErrMessage } from '@constants/validationConstants';
import { MAX_NUMBER_OF_REPETITIONS } from '@components/ModalComponents/AlarmManagementForm/constants';

export const schema = (isAutoClearMinutes: boolean) => {
	return object({
		autoClearMinutes: isAutoClearMinutes
			? object().nullable().required()
			: object().nullable().notRequired(),
		networkElementFields: array()
			.of(
				object()
					.shape({
						networkElement: object().nullable().required(mandatoryErrMessage('Network Element')),
						minutes: object().nullable().required(mandatoryErrMessage('Minutes')),
					}),
			).required(),
		isActive: boolean().required(),
		frequency: mixed<FrequencyValuesType>().oneOf(Object.values(EFrequency)).required(mandatoryErrMessage('Frequency')),
		numberOfRepetitions: mixed().when('frequency', {
			is: (frequency: TFrequency) => frequency === EFrequency.inRepetitions,
			then: number()
				.nullable()
				.max(MAX_NUMBER_OF_REPETITIONS, getMaxLengthErrMsg('Number Of Repetitions', MAX_NUMBER_OF_REPETITIONS))
				.required(),
			otherwise: number().nullable().notRequired(),
		}),
		repetitionHours: mixed().when('frequency', {
			is: (frequency: TFrequency) => frequency === EFrequency.inRepetitions,
			then: object().nullable().required(),
			otherwise: object().nullable().notRequired(),
		}),
		repetitionMinutes: mixed().when('frequency', {
			is: (frequency: TFrequency) => frequency === EFrequency.inRepetitions,
			then: object().nullable().required()
				.when('repetitionHours', {
					is: (repetitionHours: TSelectOption<number>) => repetitionHours?.value === 0,
					then: object().nullable().shape({
						value: number()
							.min(1)
							.required(),
					}),
				}),
			otherwise: object().nullable().notRequired(),
		}),
		renotify: mixed<RenotifyValuesType>().oneOf(Object.values(ERenotify)).required(mandatoryErrMessage('Renotify')),
		renotifyHours: mixed().when('renotify', {
			is: (renotify: TRenotify) => renotify === ERenotify.afterSincePrevious,
			then: object().nullable().required(),
			otherwise: object().nullable().notRequired(),
		}),
		renotifyMinutes: mixed().when('renotify', {
			is: (renotify: TRenotify) => renotify === ERenotify.afterSincePrevious,
			then: object().nullable().required()
				.when('renotifyHours', {
					is: (renotifyHours: TSelectOption<number>) => renotifyHours?.value === 0,
					then: object().nullable().shape({
						value: number()
							.min(1)
							.required(),
					}),
				}),
			otherwise: object().nullable().notRequired(),
		}),
		isEmail: boolean().required(),
		isNotification: boolean().required(),
		roles: array().nullable(),
		users: array().nullable(),
	});
};
